export const editMutations = <const>{
	ND_POHYB_ZBOZI_SELECT_MAPPER: 'ND_POHYB_ZBOZI_SELECT_MAPPER',
	ND_POHYB_SKLAD_MISTO_SELECT_MAPPER: 'ND_POHYB_SKLAD_MISTO_SELECT_MAPPER',
	ND_POHYB_RABAT_SK_SELECT_MAPPER: 'ND_POHYB_RABAT_SK_SELECT_MAPPER',
	ND_POHYB_DODAVATEL_SELECT_MAPPER: 'ND_POHYB_DODAVATEL_SELECT_MAPPER',
	ND_POHYB_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'ND_POHYB_NAKLADOVE_STREDISKO_SELECT_MAPPER',
};

export const listMutations = <const>{
	ND_POHYB_DODAVATEL_FILTER_SELECT_MAPPER: 'ND_POHYB_DODAVATEL_FILTER_SELECT_MAPPER',
	ND_POHYB_ZBOZI_FILTER_SELECT_MAPPER: 'ND_POHYB_ZBOZI_FILTER_SELECT_MAPPER',
	ND_POHYB_NAKLADOVE_STREDISKO_FILTER_SELECT_MAPPER: 'ND_POHYB_NAKLADOVE_STREDISKO_FILTER_SELECT_MAPPER',
	ND_POHYB_RABAT_SK_FILTER_SELECT_MAPPER: 'ND_POHYB_RABAT_SK_FILTER_SELECT_MAPPER',
	ND_POHYB_PRACOVNIK_FILTER_SELECT_MAPPER: 'ND_POHYB_PRACOVNIK_FILTER_SELECT_MAPPER',
	ND_POHYB_ZADAVATEL_FILTER_SELECT_MAPPER: 'ND_POHYB_ZADAVATEL_FILTER_SELECT_MAPPER',
};
